module.exports = __webpack_public_path__ + "img/Sitio_web_receptivo.33f80c21.png";